export const FILE_VAULT_COLUMN_KEYS = [
  'state',
  'name',
  'type',
  'lastModified',
  'owner',
  'actions',
] as const;

export type FileVaultColumnKey = (typeof FILE_VAULT_COLUMN_KEYS)[number];

export const DEFAULT_FILE_VAULT_COLUMNS: FileVaultColumnKey[] = [...FILE_VAULT_COLUMN_KEYS];
